import getPromoterIdFromChannel from './getPromoterIdFromChannel';
import getPromoterOfferPageLinks from './getPromoterOfferPageLinks';
var getShareableLinks = function getShareableLinks(_ref) {
  var data = _ref.data,
    structure = _ref.structure,
    toggleSharePromoterOfferLink = _ref.toggleSharePromoterOfferLink;
  var _structure$asPath = structure.asPath,
    asPath = _structure$asPath === void 0 ? '' : _structure$asPath,
    _structure$basePath = structure.basePath,
    basePath = _structure$basePath === void 0 ? '' : _structure$basePath,
    _structure$config = structure.config,
    config = _structure$config === void 0 ? {} : _structure$config,
    canonicalPath = structure.canonicalPath,
    query = structure.query;
  var promoterId = getPromoterIdFromChannel(data.channel);
  var shouldRedirectToPromoterOfferPage = !!toggleSharePromoterOfferLink && toggleSharePromoterOfferLink !== 'false';
  var promoterOfferPageLink = getPromoterOfferPageLinks({
    asPath: asPath,
    basePath: basePath,
    promoterId: promoterId,
    sellerId: query == null ? void 0 : query.sellerId
  });
  var buildLink = function buildLink(base, path) {
    return "".concat(base).concat(path);
  };
  var desktopLink = shouldRedirectToPromoterOfferPage ? promoterOfferPageLink.desktop : buildLink('https://www.magazineluiza.com.br', canonicalPath.split(basePath).join(''));
  var link = shouldRedirectToPromoterOfferPage ? promoterOfferPageLink.mobile : buildLink('https://m.magazineluiza.com.br', canonicalPath.split(basePath).join(''));
  var influenciadorMagaluLink = buildLink(config.domain, canonicalPath);
  return {
    desktopLink: desktopLink,
    link: link,
    magaly: influenciadorMagaluLink
  };
};
export default getShareableLinks;